export default __webpack_public_path__ + "static/media/a3.d82696b8.webp";